<template>
    <div class="container-passages-course-item" v-if="point && point.statistique">
        <div class="text-left d-flex justify-content-between flex-wrap gap-2">
            <div class="d-flex gap-3">
                <div class="square-status" :class="point_status">
                    <b-icon icon="check" color="white" font-scale="3" aria-hidden="true"
                        v-if="point.statistique.nb_restant == 0"></b-icon>
                    <b-icon icon="exclamation" color="white" font-scale="3" aria-hidden="true"
                        v-else-if="point.remaining_very_late_by_timestamp && point.remaining_very_late_by_timestamp.length > 0"></b-icon>
                    <b-icon icon="three-dots" color="white" font-scale="3" aria-hidden="true" v-else></b-icon>
                </div>
                <div>
                    <h6 class="container-passages-course-item-name">{{ point.nom_affiche }}</h6>
                    <div class="d-flex flex-wrap gap-1">
                        <div class="box-stats">
                            <div class="box-stats-value"><span class="box-stats-value-attendus-value">{{
                                point.statistique.nb_attendu }}</span>
                                Attendus</div>
                        </div>
                        <div class="box-stats">
                            <div class="box-stats-value"><span class="box-stats-value-passe-value">{{
                                point.statistique.nb_passe }}</span>
                                Passés</div>
                        </div>
                        <div class="box-stats">
                            <div class="box-stats-value"><span class="box-stats-value-restant-value">{{
                                nb_coming }}</span>
                                A venir</div>
                        </div>
                        <div class="box-stats">
                            <div class="box-stats-value"><span class="box-stats-value-restant-value">{{
                                nb_retard }}</span>
                                En retard</div>
                        </div>
                        <div class="box-stats">
                            <div class="box-stats-value"><span class="box-stats-value-restant-value">{{
                                nb_skipped }}</span>
                                Sauté le point</div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end" v-if="renderDetailsButton">
                <b-button class="inline-btn" @click="showDetails = !showDetails">
                    <b-icon :icon="showDetails ? 'dash' : 'plus'" aria-hidden="true"></b-icon>
                    Détails</b-button>
            </div>
        </div>
        <b-collapse :id="'collapse-' + point.id" v-model="showDetails" class="mt-2" style="margin-bottom:60px;">

            <div class="text-left"
                v-if="point.remaining_very_late_by_timestamp && point.remaining_very_late_by_timestamp.length > 0">
                <TableauCoureursRetard :coureurs="point.remaining_very_late_by_timestamp" :very_late="true">
                </TableauCoureursRetard>
            </div>
            <div class="text-left"
                v-if="point.remaining_late_by_timestamp && point.remaining_late_by_timestamp.length > 0">
                <TableauCoureursRetard :coureurs="point.remaining_late_by_timestamp"></TableauCoureursRetard>
            </div>
            <div class="text-left" v-if="point.remaining_by_timestamp && point.remaining_by_timestamp.length > 0">
                <TableauCoureursAttendus :coureurs="point.remaining_by_timestamp"></TableauCoureursAttendus>
            </div>
            <div class="text-left" v-if="point.skipped && point.skipped.length > 0">
                <TableauCoureursSautes :coureurs="point.skipped"></TableauCoureursSautes>
            </div>
        </b-collapse>


    </div>
</template>

<script>
import TableauCoureursRetard from "@/components/Live_tab/Passages/TableauCoureursRetard.vue";
import TableauCoureursAttendus from "@/components/Live_tab/Passages/TableauCoureursAttendus.vue";
import TableauCoureursSautes from "@/components/Live_tab/Passages/TableauCoureursSautes.vue";
export default {
    components: { TableauCoureursRetard, TableauCoureursAttendus, TableauCoureursSautes },
    props: ['point'],
    data() {
        return {
            showDetails: false
        }
    },
    computed: {
        renderDetailsButton() {
            if (!this.point || !this.point.statistique) {
                return false;
            }
            return this.point.statistique.nb_restant > 0 || this.point.remaining_late_by_timestamp.length > 0 || this.point.remaining_by_timestamp.length > 0;
        },
        nb_retard() {
            if (!this.point || !this.point.remaining_late_by_timestamp) {
                return 0;
            }
            return this.point.remaining_late_by_timestamp.length + this.point.remaining_very_late_by_timestamp.length;
        },
        nb_coming() {
            if (!this.point || !this.point.remaining_by_timestamp) {
                return 0;
            }
            return this.point.remaining_by_timestamp.length;
        },
        nb_skipped() {
            if (!this.point || !this.point.skipped) {
                return 0;
            }
            return this.point.skipped.length;
        },
        point_status() {
            if (!this.point || !this.point.statistique) {
                return 'square-status-waiting';
            }
            if (this.point.statistique.nb_restant == 0) {
                return 'square-status-ok';
            }
            if (this.point.remaining_late_by_timestamp && this.point.remaining_late_by_timestamp.length > 0) {
                return 'square-status-late';
            }
            return 'square-status-waiting';
        }
    },
}
</script>

<style lang="scss" scoped>
.container-passages-course-item {
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #dbe0e6;
    margin: 10px 0;
}

.square-status {
    width: 50px;
    align-self: stretch;
    border-radius: 5px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.square-status-ok {
    background-color: #00614c;
}

.square-status-late {
    background-color: #46001b;
}

.square-status-waiting {
    background-color: #b85300;
}

.box-stats {
    background-color: white;
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 5px;
    min-width: 100px;
    border: 1px solid #dbe0e6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.box-stats-value-attendus-value {
    color: #0143bd;
}

.box-stats-value-passe-value {
    color: #00614c;
}

.box-stats-value-restant-value {
    color: #b85300;
}
</style>